import { useState } from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';


export const useNavigateSearch = (defaultUrl?: string) => {
    const navigate = useNavigate();
    const [last, setLast] = useState(defaultUrl);

    return (pathname: string, params?: Record<string, string>) => {
        const localParams = params || {};
        const stringParams = `${Object.keys(localParams).filter(k => localParams[k]).filter(k => k !== 'all').map(k => localParams[k].toString().split(',').map(mk => k + '=' + mk).join('&')).join('&')}`;
        const fullPath = `${pathname}?${stringParams}`;
        if (last === fullPath) {
            return;
        }
        setLast(fullPath);
        navigate({ pathname, search: `?${createSearchParams(stringParams)}` });
    };
};
